import LogoSvg from '@/assets/wntd-wordmark-orange.svg';

interface ProductShareCardProps {
  title: string;
  imageUrl?: string;
  subtitle?: string; // Price
  storeName?: string;
}

export function ProductShareCard({ title, imageUrl, subtitle, storeName }: ProductShareCardProps) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#0a0a0a',
        padding: '48px 48px 40px',
      }}
    >
      {/* Main image container - 3:4 aspect */}
      <div
        style={{
          flex: 1,
          borderRadius: 32,
          overflow: 'hidden',
          position: 'relative',
          backgroundColor: '#1a1a1a',
        }}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={title}
            crossOrigin="anonymous"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <div
            style={{
              width: '100%',
              height: '100%',
              background: 'linear-gradient(135deg, #FF5C4D 0%, #FF6F3B 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span
              style={{
                fontSize: 72,
                fontWeight: 700,
                color: 'white',
                textAlign: 'center',
                padding: 40,
                lineHeight: 1.2,
              }}
            >
              {title}
            </span>
          </div>
        )}
        
        {/* Gradient overlay at bottom */}
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 300,
            background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%)',
          }}
        />
        
        {/* Content overlay */}
        <div
          style={{
            position: 'absolute',
            bottom: 40,
            left: 40,
            right: 40,
          }}
        >
          {storeName && (
            <p
              style={{
                fontSize: 24,
                color: 'rgba(255,255,255,0.7)',
                marginBottom: 8,
                fontWeight: 500,
              }}
            >
              {storeName}
            </p>
          )}
          <h2
            style={{
              fontSize: 48,
              fontWeight: 700,
              color: 'white',
              lineHeight: 1.2,
              marginBottom: 12,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {title}
          </h2>
          {subtitle && (
            <p
              style={{
                fontSize: 36,
                fontWeight: 600,
                color: '#FF6F3B',
              }}
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* Footer with branding */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: 40,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <img
            src={LogoSvg}
            alt="WNTD"
            style={{ height: 36 }}
          />
          <span
            style={{
              fontSize: 24,
              color: 'rgba(255,255,255,0.5)',
              fontWeight: 500,
            }}
          >
            saved on WNTD
          </span>
        </div>
        <span
          style={{
            fontSize: 24,
            color: 'rgba(255,255,255,0.4)',
            fontWeight: 400,
          }}
        >
          wntd.ai
        </span>
      </div>
    </div>
  );
}
